import { useState, useCallback } from "react";
import { useAdminClient } from "./AdminClient";
import type { QueryResult } from "./QueryResult";
import type { HttpMethod } from "../../shared/models/HttpMethod";

export type MutationParams<TBody> = {
  path: string;
  method?: HttpMethod;
  body?: TBody;
};

export function useMutation<TBody, TResult>({
  path,
  method,
  body,
}: MutationParams<TBody>): {
  result: QueryResult<TResult>;
  fetch: () => Promise<TResult | undefined>;
  clear: () => void;
} {
  const [updated] = useState<Date | undefined>();
  const { data, loading, loaded, error, fetch, clear } =
    useAdminClient<TResult>();

  const doFetch = useCallback(
    () => fetch({ path, method, body }),
    [fetch, path, method, body],
  );

  return {
    fetch: doFetch,
    clear,
    result: {
      data: data as TResult,
      loading,
      loaded,
      error,
      refresh: doFetch,
      updated,
    },
  };
}
